import React from 'react';
import { Button as MuiButton, Grid, Typography } from '@material-ui/core';
import { SizeType } from 'src/common/enumerations/cashier-preference-level';

import { BaseButton } from 'src/common/components/base-button';

import RadioButton from '../radio-button';

import { styles } from './styles';
import { useTranslation } from 'react-i18next';

interface IOptions {
  name: string;
  size: SizeType;
  buttonTestId: string;
  radioTestId: string;
}

const options: IOptions[] = [
  {
    name: 'Size_Medium',
    size: SizeType.Medium,
    buttonTestId: 'medium-button-example',
    radioTestId: 'medium-button',
  },
  {
    name: 'Size_Large',
    size: SizeType.Large,
    buttonTestId: 'large-button-example',
    radioTestId: 'large-button',
  },
];

const ZoomLevelSizes = ({ zoomLevel, setZoomLevel }): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Grid className={classes.zoomLevelBorder} style={{ background: 'white' }}>
      <Typography
        variant='h4'
        className={classes.cashierPreferencesOptionTitleHeader}
        data-testid='cashier-preferences-title-bar-text'
      >
        {t('Button_Text_Sizes')}
      </Typography>
      <Grid
        container
        data-testid='button-zoom-level-preferences-container'
        justifyContent='center'
        className={classes.zoomLevelPadding}
      >
        {options.map(({ name, size, buttonTestId, radioTestId }) => {
          const onClick = (): void => setZoomLevel(size);
          const largeBox = size === SizeType.Large ? true : false;
          return (
            <Grid
              key={buttonTestId}
              className={classes.columnFlex}
              item
              container
              direction='column'
              xs={4}
            >
              <Grid item style={{ margin: 'auto' }}>
                <BaseButton
                  data-testid={buttonTestId}
                  buttonSize={size}
                  onClick={onClick}
                  textSize={size}
                  noMax={largeBox}
                >
                  {t(name)}
                </BaseButton>
              </Grid>
              <Grid item className={classes.radioButtonFlex} style={{ margin: '0 auto' }}>
                <RadioButton isSelected={zoomLevel === size} />
                <MuiButton data-testid={radioTestId} centerRipple onClick={onClick}>
                  <Typography className={classes.lowerCase} variant='body1'>
                    {t(name)}
                  </Typography>
                </MuiButton>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
};

export default ZoomLevelSizes;
